var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.206,
    height: 28.209,
    viewBox: "0 0 28.206 28.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_001-star",
    "data-name": "001-star",
    transform: "translate(-0.023 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86",
    transform: "translate(0.023 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_384",
    "data-name": "Caminho 384",
    d: "M27.712,10.042a2.042,2.042,0,0,0-1.243-.664h0l-7.5-1.036L16.005,1.253a2.036,2.036,0,0,0-3.758,0L9.281,8.342l-7.5,1.036A2.042,2.042,0,0,0,.707,12.924l5.648,5.037L5.2,25.865a2.038,2.038,0,0,0,3.16,1.987l5.771-3.925L19.9,27.856a2.038,2.038,0,0,0,3.16-1.987L21.9,17.962l5.648-5.037A2.042,2.042,0,0,0,27.712,10.042Zm-7.561,6.782a1.008,1.008,0,0,0-.325.9l1.209,8.462L14.7,21.875a1.007,1.007,0,0,0-1.132,0L7.188,26.158l1.24-8.44a1.007,1.007,0,0,0-.325-.895L2.058,11.376l8.067-1.113a1.007,1.007,0,0,0,.792-.609l3.222-7.638a.045.045,0,0,1,.008.015l3.188,7.619a1.007,1.007,0,0,0,.792.609L26.2,11.421Z",
    transform: "translate(-0.023 0)",
    fill: "#19a4bb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.28d3794f169150dbc051ea04f02786ea.svg";
export { ForwardRef as ReactComponent };